class BrowseHappy {
  showBrowseHappy() {
    const $browseHappy = document.querySelector('browse-happy')
    let   content      = $browseHappy.innerHTML

    content = content.replace('<!--', '')
    content = content.replace('-->', '')

    $browseHappy.innerHTML = content
    $browseHappy.style.display = 'block'
  }
  init() {
    document.addEventListener('DOMContentLoaded', () => {
      if (navigator.userAgent.match(/(MSIE [6-9].0)/gm) === null) // if lte IE 9
        return false

      this.showBrowseHappy()
    }, false)
  }
}

export default new BrowseHappy().init()
